"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stargate Internal
 * Invitae API for internal apps
 *
 * The version of the OpenAPI document: 11.19.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataSourceEnumToJSON = exports.DataSourceEnumFromJSONTyped = exports.DataSourceEnumFromJSON = exports.DataSourceEnum = void 0;
/**
 * the data source the object model was derived
 * @export
 */
exports.DataSourceEnum = {
    GfbTsv: 'gfb_tsv',
    ReqrepoIcdDerived: 'reqrepo_icd_derived',
    Cies: 'cies',
    BackofficeApps: 'backoffice_apps',
    BoaWizard: 'boa_wizard',
    BoaEditor: 'boa_editor',
    BoaConfirm: 'boa_confirm',
    ReqrepoStructuredData: 'reqrepo_structured_data',
    Other: 'other'
};
function DataSourceEnumFromJSON(json) {
    return DataSourceEnumFromJSONTyped(json, false);
}
exports.DataSourceEnumFromJSON = DataSourceEnumFromJSON;
function DataSourceEnumFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.DataSourceEnumFromJSONTyped = DataSourceEnumFromJSONTyped;
function DataSourceEnumToJSON(value) {
    return value;
}
exports.DataSourceEnumToJSON = DataSourceEnumToJSON;
